/**
 * @file Pricing Card Toggle
 */

import { gsap } from 'gsap';

/**
 * Pricing Card Toggle component
 */
const vPricingCardToggle = () => {
	const pricingCards = document.querySelectorAll( '.v-pricing-card-toggle, .v-pricing-card-toggle-dual' );

	if ( ! pricingCards.length ) {
		return;
	}

	[ ...pricingCards ].forEach( ( card ) => {
		const cardCosts = card.querySelectorAll( '.v-pricing-card-toggle__price' );
		const cardCta  	= card.querySelectorAll( '.v-pricing-card-toggle__btn' );
		const toggles  	= card.querySelectorAll( '.v-pricing-card-toggle__toggle' );

		[ ...toggles ].forEach( ( toggle ) => {
			toggle.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				[ ...cardCosts ].forEach( ( cardCost, key ) => {
					[ ...toggles ].forEach( ( t ) => t.parentElement.classList.remove( 'active' ) );
					gsap.timeline( {
						defaults: {
							ease:     'sine.out',
							duration: 0.3,
						},
					} )
						.to( cardCost, {
							opacity:    0,
							onComplete: () => {
								cardCost.textContent = toggle.getAttribute( 'data-price' );
								cardCta[ key ].href  = toggle.getAttribute( 'data-url' );
							},
						} )
						.to( cardCost, { opacity: 1 } );
					toggle.parentElement.classList.add( 'active' );
					document.dispatchEvent( new CustomEvent( 'vPricingCardToggle', { detail: { card, toggle } } ) );
				} );
			} );
		} );
	} );
};

export default vPricingCardToggle;
